import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export const useAdminStore = create()(
  persist(
    (set, get) => ({
      course: get()?.course || {},
      setCourse: (course) => set({ course }),
      orgId: get()?.orgId || '',
      setOrgId: (orgId) => set({ orgId }),
      orgName: get()?.orgName || '',
      setOrgName: (orgName) => set({ orgName }),
    }),
    {
      name: 'gsk-admin',
      storage: createJSONStorage(() => localStorage),
    }
  )
)
